//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    /**
     * Story's author
     */
    author: {
      type: String,
      required: true
    },
    /**
     * Story's description
     */
    description: {
      type: String,
      required: true
    }
  },
  computed: {
    memberImage () {
      return this.getStaticsObject(`/members-stories/member_${this.author.replace(/\./g, '')}.jpeg`)
    }
  }
}
